import { useSelector } from "react-redux";
const IsLogin = () => {
  const token = useSelector((state) => state?.Auth?.user?.bearer);
  if (token) {
    if (token !== "") {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export default IsLogin;
// async function isLogin(){
//     var token = localStorage.getItem('token')
//     var user = localStorage.getItem('user')
//     var user_data = await JSON.parse(localStorage.getItem('user_data'))
//     if(token){
//         if (token !== ''){
//             if(user_data && user){
//                 return true
//             }
//         }
//     }
//     return false
// }
